import React, { useEffect, useRef, useState } from "react";
import classes from "./WebTraffic.module.css";
import { useLocation } from "react-router-dom";
import aloozaGif from "../../assets/video/alooza.gif";
import Utils from "../../Utils";
import { IconButton } from "@material-ui/core";
import { Close } from "@material-ui/icons";

function WebTraffic() {
  const location = useLocation();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (location.pathname.match(/.*\/((newbook)|edit\/).*/)) {
      setShow(true);
    }
  }, [location.pathname]);

  return (
    <div className={Utils.getClasses(classes.main, show ? classes.hidden : "")}>
      <div className={classes.wrapper}>
        <IconButton
          size="small"
          aria-label="hide"
          onClick={() => setShow(true)}
          className={classes.closeButton}
          color="white"
        >
          <Close fontSize="inherit" color="inherit" />
        </IconButton>

        <div className={classes.aloozaContainer}>
          <img className={classes.alooza} src={aloozaGif} alt="alooza" />
        </div>
        <div className={classes.content}>
          <div>
            <span>Visitors:</span>
            <Slider
              opts={[
                "20000",
                "20015",
                "20025",
                "20030",
                "20045",
                "20050",
                "20055",
                "20068",
                "20075",
                "20079",
                "20080",
                "20084",
                "20090",
                "20106",
              ]}
            />
          </div>
          <div>
            <span>Books Published:</span>
            <Slider
              opts={[
                "12000",
                "12033",
                "12048",
                "12056",
                "12067",
                "12078",
                "12084",
                "12096",
                "12101",
                "12120",
                "12124",
                "12134",
              ]}
            />
          </div>
          <div>
            <span>Royalty Earned: RS</span>
            <Slider
              opts={[
                "400012",
                "40089",
                "40105",
                "40116",
                "40120",
                "40125",
                "40130",
                "40135",
                "40140",
                "40145",
                "40150",
                "40155",
              ]}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

const Slider = ({ opts, interval = 1500 }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const timeoutRef = useRef(null);

  useEffect(() => {
    if (opts.length <= 1) return;

    const nextSlide = () => {
      setIsAnimating(true);

      // Set timeout for the exit animation duration
      timeoutRef.current = setTimeout(() => {
        setActiveIndex((prevIndex) => (prevIndex + 1) % opts.length);
        setIsAnimating(false);
      }, 400); // Half the interval for the animation
    };

    const intervalId = setInterval(nextSlide, interval);

    return () => {
      clearInterval(intervalId);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [opts.length, interval]);

  return (
    <ul className={classes.slider}>
      {opts.map((opt, index) => (
        <li
          key={opt}
          className={Utils.getClasses(
            classes.sliderItem,
            index === activeIndex ? classes.active : "",
            isAnimating ? classes.animating : ""
          )}
        >
          {opt}
        </li>
      ))}
    </ul>
  );
};

export default WebTraffic;
